export const ORGANIZATION = 'organization';
export const FULL_NAME = 'name'
export const SURE_NAME = 'given-name';
export const LAST_NAME = 'family-name';
export const STREET = 'street-address';
export const ADDRESS_ADDITION = 'address-line2';
export const ZIP = 'postal-code';
export const CITY = 'address-level2';
export const COUNTRY = 'country-name';
export const EMAIL = 'email';
export const BILLING_EMAIL = 'billing email';
export const PHONE = 'tel';
export const NEW_PASSWORD = 'new-password';
export const CURRENT_PASSWORD = 'current-password';
